export default __webpack_public_path__ + "static/media/310.4335e28e.png";